export default {
  params: {
    delivery_days: '1',
    delivery_date: '',
    months: '12',
    provider: '',
    warehouse:'',
    branchoffice: '',
    observation: ''
  },
  ag_grid:{
    selectedTheme:'ag-theme-balham'
  },
  transactions:[],
  projects: [],
  loading:{
    preloader:false,
    transactions:false,
  },
  paramsquery:{
    is_customer: false,
    is_provider: false,
    is_employee: false,
    filter_customer: [],
    filter_provider: [],
    filter_employee: [],
    paginate: true,
    page: 1,
    perPage: 50,
    query: '',
    sortBy: 'id',
    sort: 'ASC',
  },
  paramsTable: {
    paginate: true,
    page: 1,
    perPage: 30,
    filter: ""
  },
  projectsTable: {
    items: [],
    columns: [
      {
        name: "Código",
        field: "code",
        format: "text"
      },
      {
        name: "Descripción",
        field: "description",
        format: "text"
      },
      {
        name: "Tipo Negocio",
        field: "type",
        format: "text"
      },
      {
        name: "Estado",
        field: "status",
        format: "text"
      },
      {
        name: "Opciones",
        field: "options",
        format: "text"
      }
    ],
    pagination: {},
    params: {
      paginate: true,
      page: 1,
      perPage: 30,
      filter: ""
    }
  }
};



// WEBPACK FOOTER //
// ./src/modules/project-movements/state.js